<template>
  <div>
    <tud-drawer></tud-drawer>
    <tud-toolbar></tud-toolbar>

    <main>
      <v-container fluid class="pa-1">
        <!-- <transition name="slide-x-transition" mode="out-in" appear> -->
          <v-layout column align-center :key="$route.fullPath" child-flex>
            <router-view></router-view>
          </v-layout>
        <!-- </transition> -->
      </v-container>
    </main>

    <tud-snack :messages="messages" :visible="visibleMessages"></tud-snack>

    <!-- <tud-footer></tud-footer> -->
  </div>
</template>

<script>
  import Drawer from '@/components/Drawer.vue'
  import Toolbar from '@/components/Toolbar.vue'
  import Footer from '@/components/Footer.vue'
  import Snackbar from '@/components/Snackbar.vue'

  export default {
    components: {
      'tud-drawer': Drawer,
      'tud-toolbar': Toolbar,
      'tud-footer': Footer,
      'tud-snack': Snackbar
    },
    computed: {
      messages () {
        return this.$store.getters.snacksMessages
      },
      visibleMessages () {
        return this.$store.getters.snacksVisible
      }
    }
  }
</script>

<style>
  [data-tooltip][data-tooltip-location='right']:hover:before {
    font-family: "Roboto"
  }
</style>



// WEBPACK FOOTER //
// Layout.vue?b5eebdae